import React from 'react';
import ReactDOM from 'react-dom';
import './styles/base.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

/**
 * Décision 4 du plan de passation : le mock n'existe que pour le CRA dev
 * server. La garde sur `NODE_ENV === 'development'` permet à CRA de l'éliminer
 * du bundle de production par mort-code — `mockStateForPath` n'est même pas
 * importé en prod.
 */
let initialState = window.__PRELOADED_STATE__;
if (!initialState && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { mockStateForPath } = require('./mockState');
  initialState = mockStateForPath(window.location.pathname);
}

ReactDOM.hydrate(
  <BrowserRouter>
    <App props={initialState} />
  </BrowserRouter>,
  document.getElementById('root'),
);

serviceWorker.unregister();
